document.addEventListener('DOMContentLoaded', function () {
  const mobileMenuButtons = document.querySelectorAll(
    '.footer__main--menu__list--button'
  );

  if (mobileMenuButtons) {
    mobileMenuButtons.forEach((button) => {
      button.addEventListener('click', function (e) {
        e.preventDefault();
        const item = button.parentElement;

        if (item.classList.contains('is-active')) {
          item.classList.remove('is-active');
          button.classList.remove('is-active');
        } else {
          item.classList.add('is-active');
          button.classList.add('is-active');
        }
      });
    });
  }
});
